module.exports = __webpack_public_path__ + "static/assets/645df4e0c64d5cb45c795014b7924194.svg";